import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { getResetByTag, rem, colors } from '../../../styles';
var autoCompleteDropdownInnerStyles = function autoCompleteDropdownInnerStyles(_ref) {
  var noResultItem = _ref.noResultItem;
  return /*#__PURE__*/css("border-bottom:", rem(1), " solid ", colors.coolGray_300, ";color:", noResultItem ? colors.blue_500 : 'unset', ";padding:", rem(12, 12, 12, 0), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:autoCompleteDropdownInnerStyles;"));
};
var resetStyles = getResetByTag('pre');
var StyledAutoCompleteDropdownInner = /*#__PURE__*/_styled('pre', process.env.NODE_ENV === "production" ? {
  target: "e104x9t80"
} : {
  target: "e104x9t80",
  label: "StyledAutoCompleteDropdownInner"
})(resetStyles, autoCompleteDropdownInnerStyles);
export default StyledAutoCompleteDropdownInner;